import styles from 'styled-components';

export const Container = styles.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
